export function MetadataDisplay({
  metadata
}: {
  metadata: {
    expirationDate: string;
    serialNumber: string;
    issuer: string;
    subject: string;
  };
}) {
  return (
    <div className="flex flex-col">
      <div className="space-between flex flex-row gap-2">
        <p className="font-bold">Expiration Date: </p>
        <code>{metadata.expirationDate}</code>
      </div>
      <div className="space-between flex flex-row gap-2">
        <p className="font-bold">Serial number: </p>
        <code>{metadata.serialNumber}</code>
      </div>
      <div className="space-between flex flex-row gap-2">
        <p className="font-bold">Issuer: </p>
        <code>{metadata.issuer}</code>
      </div>
      <div className="space-between flex flex-row gap-2">
        <p className="font-bold">Subject: </p>
        <code>{metadata.subject}</code>
      </div>
    </div>
  );
}
